import { render, staticRenderFns } from "./indexC.vue?vue&type=template&id=86001dbc&scoped=true"
import script from "./indexC.vue?vue&type=script&lang=js"
export * from "./indexC.vue?vue&type=script&lang=js"
import style0 from "./indexC.vue?vue&type=style&index=0&id=86001dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86001dbc",
  null
  
)

export default component.exports